import { Prompt, StoryState } from '@common/store/story/models/story.models';
import { createReducer, on } from '@ngrx/store';
import { StoryHttpActions } from '@src/suite/common/store/story/actions/story.actions';

export const initialState: StoryState = { prompts: [] };
export const storiesReducer = createReducer(
    initialState,
    on(StoryHttpActions.loadPromptsSuccess, (state, action): StoryState => {
        const prompts: Array<Prompt> = [];
        Object.keys(action.data).forEach(key => {
            prompts.push({ title: key, value: action.data[key] });
        });
        return { ...state, prompts: prompts };
    })
);
